module.exports = __webpack_public_path__ + "img/icon-grill.e1ef34ae.svg";